import axios from 'src/store/vue-axios/axios.js'

export default class Leads {
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API ENDPOINTS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // LEADS -> /leads/*
  static leadsUrl = () => '/leads'
  // LEADS -> /leads/${id}*
  static leadsByIdUrl = (id) => `/leads/${id}`
  static visitedLeadsByIdUrl = (id) => `/leads/${id}/visited`
  // ONBOARDINGS -> /management/onboardings
  static onboardingsUrl = () => '/management/onboardings'

  // ONBOARDINGS -> /management/onboardings
  static onboardingsUrl = () => '/management/onboardings'

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API IMPLEMENTATIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // LEADS -> /leads/*
  static async getLeads (config) {
    return axios.get(this.leadsUrl(), config)
  }

  // LEADS -> /leads/${id}*
  static async getLeadsById (id) {
    return axios.get(this.leadsByIdUrl(id))
  }

  static async postVisitedLeadsById (id, payload) {
    return axios.post(this.visitedLeadsByIdUrl(id), payload)
  }

  // ONBOARDINGS -> /management/onboardings
  static async getOnboardingsByName (config) {
    return axios.get(this.onboardingsUrl(), config)
  }
}
